export default class Timer {
    setTimer(params) {
        if (!this.isActive) {
            this.updateTimeoutTime = 1000;
            this.currentTime = new Date();
            this.maxTime = params.maxTime;
            this.callback = params.callback;
            this.isActive = true;

            this._setTimeoutAction();
            this.reset = this.reset.bind(this);
            this.stop = this.stop.bind(this);
        }
    }

    reset() {
        this.currentTime = new Date();
        if (!this.isActive) {
            this.isActive = true;
            this._setTimeoutAction();
        }
    }

    stop() {
        this.isActive = false;
    }

    _setTimeoutAction() {
        setTimeout(() => {
            let diffInSeconds = Math.floor((new Date() - this.currentTime) / 1000);
            if (diffInSeconds >= this.maxTime && this.isActive) {
                this.callback && this.callback();
                this.isActive = false;
            } else {
                if (this.isActive) {
                    this._setTimeoutAction();
                }
            }
        }, this.updateTimeoutTime);
    }
}
